import WhatsAppSipTimeConditionsAPI from 'dashboard/api/whatsappSip/timeConditions';

export const state = {
  records: [],
  groups: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getRecords: $state => $state.records,
  getGroups: $state => $state.groups,
  getUIFlags: $state => $state.uiFlags,
  getById: $state => id => $state.records.find(r => r.id === id),
};

export const actions = {
  async fetch({ commit }, params = {}) {
    commit('SET_UI_FLAG', { isFetching: true });
    try {
      const { data } = await WhatsAppSipTimeConditionsAPI.get(params);
      const conditions = data.time_conditions || data || [];
      commit('SET_RECORDS', conditions);
      return conditions;
    } finally {
      commit('SET_UI_FLAG', { isFetching: false });
    }
  },

  async show(_, id) {
    const { data } = await WhatsAppSipTimeConditionsAPI.show(id);
    return data.time_condition || data;
  },

  async create({ commit }, conditionData) {
    commit('SET_UI_FLAG', { isCreating: true });
    try {
      const { data } = await WhatsAppSipTimeConditionsAPI.create(conditionData);
      const condition = data.time_condition || data;
      commit('ADD_RECORD', condition);
      return condition;
    } finally {
      commit('SET_UI_FLAG', { isCreating: false });
    }
  },

  async update({ commit }, { id, data: updateData }) {
    commit('SET_UI_FLAG', { isUpdating: true });
    try {
      const { data } = await WhatsAppSipTimeConditionsAPI.update(
        id,
        updateData
      );
      const condition = data.time_condition || data;
      commit('UPDATE_RECORD', condition);
      return condition;
    } finally {
      commit('SET_UI_FLAG', { isUpdating: false });
    }
  },

  async delete({ commit }, id) {
    commit('SET_UI_FLAG', { isDeleting: true });
    try {
      await WhatsAppSipTimeConditionsAPI.delete(id);
      commit('DELETE_RECORD', id);
    } finally {
      commit('SET_UI_FLAG', { isDeleting: false });
    }
  },

  async fetchGroups({ commit }) {
    const { data } = await WhatsAppSipTimeConditionsAPI.getGroups();
    const groups = data.groups || data || [];
    commit('SET_GROUPS', groups);
    return groups;
  },
};

export const mutations = {
  SET_UI_FLAG($state, data) {
    $state.uiFlags = { ...$state.uiFlags, ...data };
  },

  SET_RECORDS($state, records) {
    $state.records = records;
  },

  SET_GROUPS($state, groups) {
    $state.groups = groups;
  },

  ADD_RECORD($state, record) {
    $state.records = [record, ...$state.records];
  },

  UPDATE_RECORD($state, record) {
    const index = $state.records.findIndex(r => r.id === record.id);
    if (index !== -1) {
      $state.records.splice(index, 1, { ...$state.records[index], ...record });
    }
  },

  DELETE_RECORD($state, id) {
    $state.records = $state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
